import useToasts, { Toast as ToastType } from "./useToasts";
import { useDownload } from "../../hooks";
import { useEffect, useRef } from "react";
import Toast from "./Toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { CircularProgress } from "@ui";

interface Props {
    toast: ToastType;
}

// Toast for background jobs: shows progress/spinner and triggers the download once ready
const ProgressToast = ({ toast }: Props) => {
    const { id, typeId, title, description, progress, type, failed } = toast;
    const { removeToast } = useToasts();
    const download = useDownload();
    const downloadReady = progress === 100 && toast.data?.status === "success";
    const downloadUrl = (downloadId: string) => `${process.env.NEXT_PUBLIC_BACKEND_HOST}download/${downloadId}`;
    const cleanUpFinished = useRef<boolean>(false);

    useEffect(() => {
        if (failed || cleanUpFinished.current === true) return;

        let toastReady = false;
        if (type === "download" && downloadReady) {
            download?.(downloadUrl(typeId), description);
            toastReady = true;
        } else if (type === "progress" && progress === 100) {
            toastReady = true;
        }

        if (toastReady) {
            toast.callback?.();
            setTimeout(() => removeToast(id), 3000);
            cleanUpFinished.current = true;
            // return () => clearTimeout(timeout); // we dont use clear timeout here, because its cleared by the update before it could run
        }
    }, [toast, downloadReady, removeToast]);

    return <Toast toastId={id}
        title={title}
        description={failed ? "Es ist ein unbekannter Fehler aufgetreten." : (downloadReady ? "Klicke um den Download manuell zu starten" : description)}
        onPress={downloadReady ? () => download(downloadUrl(typeId), description) : undefined}
        rightContent={
            failed ? <span
                className="tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-bg-errorLight tw-text-error"
            >
                <FontAwesomeIcon icon={faExclamationTriangle} />
            </span> : ((type === "download" && !downloadReady) || progress !== 100 ?
                <span className="tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-bg-accents-1">
                    <CircularProgress spin={progress === undefined || progress === 0 || progress === 100}
                        progress={progress} radius={12} stroke={2}
                        withoutText
                    />
                </span> : <span
                    className="tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-bg-successLight tw-text-success"
                >
                    <FontAwesomeIcon icon={faCheck} />
                </span>)
        }
    />;
};

export default ProgressToast;